import { create } from 'zustand';

interface PreferencesState {
  manualScoringEnabled: boolean;
  initializedForUser: string | null;
  hydratePreferences: (userId?: string, isAdmin?: boolean) => void;
  setManualScoringEnabled: (enabled: boolean) => void;
  reset: () => void;
}

const getStorageKey = (userId?: string | null) =>
  `preferences_${userId || 'guest'}`;

export const usePreferencesStore = create<PreferencesState>((set, get) => ({
  manualScoringEnabled: false,
  initializedForUser: null,

  hydratePreferences: (userId, isAdmin = false) => {
    const storageKey = getStorageKey(userId);
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        set({
          manualScoringEnabled:
            typeof parsed.manualScoringEnabled === 'boolean'
              ? parsed.manualScoringEnabled
              : isAdmin,
          initializedForUser: userId || 'guest',
        });
        return;
      }
    } catch (error) {
      console.warn('Failed to hydrate preferences, using defaults.', error);
    }

    set({
      manualScoringEnabled: isAdmin,
      initializedForUser: userId || 'guest',
    });
  },

  setManualScoringEnabled: (enabled) => {
    const state = get();
    const storageKey = getStorageKey(state.initializedForUser);
    set({ manualScoringEnabled: enabled });
    try {
      localStorage.setItem(
        storageKey,
        JSON.stringify({ manualScoringEnabled: enabled })
      );
    } catch (error) {
      console.warn('Failed to persist preferences', error);
    }
  },

  reset: () => {
    set({ manualScoringEnabled: false, initializedForUser: null });
  },
}));
